module.exports = __webpack_public_path__ + "static/media/scheudling-import-excel-example.7b823b4a.png";